// PGCredentialsPricingForm
import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { change, Field, FieldArray, reduxForm } from 'redux-form';
import { Accordion, Alert, FormElems } from 'components';
import { connect } from 'react-redux';
import { showLoader, hideLoader } from 'redux/common/loader/loader.actions';
import { bindActionCreators } from 'redux';
import {
    pgCredentialsOnboardingFormValidator,
    pgCredentialsPricingFormValidator,
} from './validator';
import { fetchPaymentModesRequest } from 'containers/MerchantOnboard/redux/merchantOnBoard.actions';
import { useHistory } from 'react-router-dom';

import { compose } from 'redux';
import {
    getLabelValuePG,
    getPGCredentialPricingRequestFromValues,
    getSelectedPayModePGMID,
    getSlabData,
    getSlabDataWithDetails,
    schemensMapp,
} from '../constants';
import { toast } from 'react-toastify';
import {
    createPaymentGatewayCredentialStepRequest,
    resetPaymentGatewayCredentialCreateFormData,
    resetPaymentGatewayCredentialUpdateFormData,
    updatePaymentGatewayCredentialStepRequest,
    fetchPaymentGatewayCredentialDataRequest,
    fetchFormDataPricingSectionRequest
} from '../redux/paymentGatewayCredentials.actions';
import {capitalize, isEmpty } from 'lodash';
import { capitalizeStringWithUnderscores } from 'utils/helperMethods';
import { POST } from 'utils/fetchWrappers';
import { API_FETCH_BASIC_DATA } from 'utils/API/apiUrls';
import { apiStatusCodes } from 'utils/API/apiStatusCodes';
import { ERROR_MESSAGES } from 'utils/constants/toastMessages';
import { BASIC_FORM_DATA_RESPONSE } from '../mock/basicformdata.res';
import { MOCK_API_VALUE } from 'utils/constants/commonValues';

const BASICFORMDATACONSTANT = 'pgMidSurchargeSection';

const PGCredentialsPricingForm = ({
    actions,
    isViewMode,
    auth,
    staticData,
    formData,
    handleSubmit,
    paymentGatewayCredentialsData,
    isEditMode,
    sectionType,
    nextPath,
    previousPath,
    formIdentifier,
    initialValues,
    feeConfigList,
    merchantData,
}) => {
    const history = useHistory();

    // console.log("fee config list", feeConfigList);
    // console.log("paymentGatewayCredentialsData....", paymentGatewayCredentialsData);

const { paymentModes } = merchantData;
const { payValues } = staticData;
const getOptions = ({ data, labelField, valueField, isStringArray }) => {
    if (isStringArray) {
        return data.map(item => {
            return {
                name: capitalize(item),
                value: item,
            };
        });
    }
    return data.map(item => {
        return {
            ...item,
            name: item[labelField],
            value: item[valueField],
        };
    });
};

const [defaultBasicFormData, setDefaultBasicFormData] =  useState([]);
const getPayOptions = (paymentModes, payValues) => {
    const formatValues = {
        DEBIT_CARD_OPTIONS: [],
        DEBIT_CARD_BUSINESS_SOURCE_OPTIONS: [],
        CREDIT_CARD_OPTIONS: [],
        CREDIT_CARD_BUSINESS_SOURCE_OPTIONS: [],
        UPI_OPTIONS: [],
        UPI_MANDATE_OPTIONS: [],
        UPI_BUSINESS_SOURCE: [],
        UPI_ACCOUNT_TYPES: [],
        NG_OPTIONSNET_BANKI: [],
        WALLET_OPTIONS: [],
    };
    if (paymentModes) {
        const {
            debitCards,
            debitCardBusinessSource,
            creditCards,
            creditCardBusinessSource,
            // upi,
            netbanking,
            upiAccountType,
            upiBusinessSource,
            wallets,
        } = paymentModes;
        if (debitCards && !isEmpty(debitCards)) {
            formatValues.DEBIT_CARD_OPTIONS = getOptions({
                data: debitCards,
                labelField: 'subModeNameUI',
                valueField: 'subMode',
            });
        }
        if (debitCardBusinessSource && !isEmpty(debitCardBusinessSource)) {
            formatValues.DEBIT_CARD_BUSINESS_SOURCE_OPTIONS = getOptions({
                data: debitCardBusinessSource,
                isStringArray: true,
            });
        }
        if (creditCards && !isEmpty(creditCards)) {
            formatValues.CREDIT_CARD_OPTIONS = getOptions({
                data: creditCards,
                labelField: 'subModeNameUI',
                valueField: 'subMode',
            });
        }
        if (creditCardBusinessSource && !isEmpty(creditCardBusinessSource)) {
            formatValues.CREDIT_CARD_BUSINESS_SOURCE_OPTIONS = getOptions({
                data: creditCardBusinessSource,
                isStringArray: true,
            });
        }
        if (upiAccountType && !isEmpty(upiAccountType)) {
            const resultObj = {};
            for (const [businessSource, accountTypes] of Object.entries(
                upiAccountType
            )) {
                const formattedAccountTypes = accountTypes.map(type => ({
                    accountTypesNameUI: capitalizeStringWithUnderscores(type),
                    accountTypesValue: type,
                }));
                resultObj[businessSource] = formattedAccountTypes;
            }
            formatValues.UPI_ACCOUNT_TYPES = !isEmpty(resultObj)
                ? resultObj
                : [];
        }
        // if (upi && !isEmpty(upi)) {
        //     formatValues.UPI_OPTIONS = getOptions({
        //         data: upi,
        //         labelField: 'subModeNameUI',
        //         valueField: 'subMode',
        //     });
        //     formatValues.UPI_MANDATE_OPTIONS = getOptions({
        //         data: upi,
        //         labelField: 'subModeNameUI',
        //         valueField: 'subMode',
        //     });
        // }
        // if (upiBusinessSource && !isEmpty(upiBusinessSource)) {
        //     formatValues.UPI_BUSINESS_SOURCE = getOptions({
        //         data: upiBusinessSource,
        //         isStringArray: true,
        //     });
        // }
        if (netbanking && !isEmpty(netbanking)) {
            formatValues.NET_BANKING_OPTIONS = getOptions({
                data: netbanking,
                labelField: 'subModeNameUI',
                valueField: 'subMode',
            });
        }
        if (wallets && !isEmpty(wallets)) {
            formatValues.WALLET_OPTIONS = getOptions({
                data: wallets,
                labelField: 'subModeNameUI',
                valueField: 'subMode',
            });
        }
    }
    return formatValues;
};
    // const location = useLocation();
    const { staticInfo } = staticData;
    const { createFormData, editFormData } = paymentGatewayCredentialsData;
    // console.log("pricing section form", createFormData, editFormData);

    const [paymodeData, setpayModesData] = useState([]);
    const [walletData, setWalletData] = useState([]);
    // useEffect(() => {
    //     let req = {};
    //     console.log("section type", sectionType);
    //     if (!isEditMode && !isViewMode && !pricing_section_initial_data.isSuccess) {
    //         req = {
    //             entityCode: sectionType,
    //             sectionType,
    //         };
    //     }

    //     actions.fetchFormDataPricingSectionRequest(req);
    // }, []);
    // console.log("pricing_section_initial_data...", pricing_section_initial_data)
    useEffect(() =>{
        // actions.fetchPaymentGatewayCredentialDataRequest({
        //     pgMidReferenceId: parseInt(formIdentifier),
        // });
        if(isEditMode || isViewMode){
            actions.showLoader();
            actions.fetchPaymentGatewayCredentialDataRequest({
                pgMidReferenceId: parseInt(formIdentifier),
            });
        }
    }, [formIdentifier]);


    useEffect(() => {
        // Listen for changes in paymentGatewayCredentialsData to hide loader on success
        // if(isEditMode || isViewMode){
        //     actions.showLoader();
        // }
        // if (editFormData.isSuccess ) {
        //     actions.hideLoader(); // Hide loader on successful data fetch
        // }
    }, [editFormData.isSuccess]);


    useEffect(() => {
        if (
            createFormData.isSuccess &&
            createFormData.sectionType === sectionType
        ) {
            toast.success('PG Credential request created successfully');
            onNext();
        }
        return () => {
            if (
                createFormData.isSuccess &&
                createFormData.sectionType === sectionType
            ) {
                actions.resetPaymentGatewayCredentialCreateFormData();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [createFormData.isSuccess, createFormData.sectionType]);

    useEffect(() => {
        if (
            editFormData.isSuccess &&
            editFormData.sectionType === sectionType
        ) {
            if(!isViewMode){
                toast.success('PG Credential request updated successfully');
            }
            onNext();
        }
        return () => {
            if (
                editFormData.isSuccess &&
                editFormData.sectionType === sectionType
            ) {
                actions.resetPaymentGatewayCredentialUpdateFormData();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editFormData.isSuccess, editFormData.sectionType]);

    const basicFormDataCall = async() => {
        try {
            let response = BASIC_FORM_DATA_RESPONSE();
            if (!MOCK_API_VALUE) {
                response = await POST(API_FETCH_BASIC_DATA, {
                    sectionType:BASICFORMDATACONSTANT,
                    entityCode: BASICFORMDATACONSTANT
                })
            }
            if (response?.data?.statusCode === apiStatusCodes.SUCCESS2) {
                setDefaultBasicFormData(response?.data?.basicSectionData);
            } else {
                toast.error(response?.data?.errorMessage || ERROR_MESSAGES.FALLBACK_ERROR)
                history.push('/payment-gateway-credentials');
            }
        } catch(e) {
            toast.error(ERROR_MESSAGES.FALLBACK_ERROR)
            history.push('/payment-gateway-credentials');
        }

    }

    // useEffect(() => {
    //     console.log("set default data basis on pay mode data", feeConfigList);
    // }, [feeConfigList]);

    // console.log("default basic section data", defaultBasicFormData);

    useEffect(() => {
        //fetching paymodes data;
        actions.fetchPaymentModesRequest();
        // if (Object.keys(feeConfigList).length) {
            basicFormDataCall();

        // }

    }, []);

    useEffect(() => {
        setpayModesData(merchantData?.paymentModes?.netbanking);
    }, [merchantData?.paymentModes?.netbanking]);

    useEffect(() => {
        setWalletData(merchantData?.paymentModes?.wallets);
    }, [merchantData?.paymentModes?.wallets]);

    const resetErrors = () => {
        actions.resetPaymentGatewayCredentialCreateFormData();
    };

    const onNext = () => {
        if(!isEditMode){
            resetErrors();
        }
        history.push('/payment-gateway-credentials');
    };
    const onBack = () => {
        history.push(previousPath);

    };
    const memoizedPay = useMemo(() => getPayOptions(paymentModes, payValues), [
        paymentModes,
        payValues,
    ]);
    const {
        NET_BANKING_OPTIONS,
    } = memoizedPay;

    const handleFormSubmit = values => {
        const request = getPGCredentialPricingRequestFromValues({ values ,NET_BANKING_OPTIONS ,isEditMode});

        request.pgMerchantDetailId = formIdentifier;
        console.log("request",request);


        if (isViewMode) {
            onNext()
        }
        else if (isEditMode) {
            actions.updatePaymentGatewayCredentialStepRequest(
                request,
                sectionType
            );
        } else {
            actions.createPaymentGatewayCredentialStepRequest(
                request,
                sectionType
            );
        }
    };

    const errorMessage =
        createFormData &&
        createFormData.error &&
        createFormData.error.errorMessage;


    // useEffect(() => {
    //     if(isEditMode || isViewMode){
    //         console.log("is view,isedit", isViewMode,isEditMode);
    //         actions.fetchPaymentGatewayCredentialDataRequest({
    //         pgMidReferenceId: parseInt(formIdentifier),
    //     });
    // }


    // }, [isEditMode, isViewMode, actions]);
    // useEffect(() => {
    //     // Always fetch data on component mount
    //     if (isEditMode || isViewMode) {
    //         console.log("Fetching Payment Gateway Credential Data...");
    //         console.log("isEditData, is View", isEditMode, isViewMode);
    //         actions.fetchPaymentGatewayCredentialDataRequest({
    //             pgMidReferenceId: parseInt(formIdentifier),
    //         });
    //     }
    // }, [isEditMode, isViewMode, actions]); // Dependencies included to avoid stale references

    // console.log(feeConfigList, "feeConfigList");
    //
    // if(feeConfigList){
    //
    // }

    return (
        <form
            className="pg-credentials-pricing-form card"
            onSubmit={handleSubmit(handleFormSubmit)}
        >
            <h2 className="tab-title">Pricing Details</h2>
            {errorMessage ? (
                <Alert customClass="error-msg">{errorMessage}</Alert>
            ) : null}
            {feeConfigList &&
                Object.keys(feeConfigList).map((payModeSection, index) => {
                    return (
                        <>
                            <Accordion
                                key={`payModeSection-${index}`}
                                customClass={`custom-accordion ${payModeSection}`}
                                isOpened={index === 0 ? true : false}
                                id={payModeSection}
                                upperComponent={
                                    <h3 className="accordion-tile">
                                        {payModeSection.length <= 3
                                            ? payModeSection
                                                  .split('-')
                                                  .join(' ')
                                                  .toUpperCase()
                                            : payModeSection
                                                  .split('-')
                                                  .join(' ')}
                                    </h3>
                                }
                                lowerComponent={
                                    <>
                                        <FieldArray
                                            name={payModeSection}
                                            id={payModeSection}
                                            component={renderComponent}
                                            // schemeOptions={getSchemeOptions(
                                            //     surchargeOptions.schemes
                                            // )}
                                            paymodeData={paymodeData}
                                            walletData={walletData}
                                            props={{
                                                isViewMode,
                                                payModeSection,
                                                payModeSectionData:
                                                    feeConfigList[
                                                        payModeSection
                                                    ],

                                                defaultBasicFormData:defaultBasicFormData
                                            }}
                                        />
                                    </>
                                }
                            />
                        </>
                    );
                })}
            <div className="form-section action">
                <FormElems.Button
                    id="back-btn"
                    buttonType="secondary"
                    text="Back"
                    type="button"
                    handleClick={onBack}
                    customClass="back-btn"
                />
                <FormElems.Button
                    id="next-btn"
                    buttonType="primary"
                    text="Next"
                />
            </div>
        </form>
    );
};

const renderComponent = ({
    fields,
    meta: { error, submitFailed },
    schemeOptions,
    isViewMode,
    payModeSection,
    payModeSectionData,
    defaultBasicFormData,
    paymodeData,
    walletData
}) => {

    // console.log("render compppp", payModeSectionData, payModeSection, defaultBasicFormData);
    // let isSingleSlab = getSelectedPayModePGMID(payModeSection)?.isSingleSlab;
    // paymentType: 'DC', isSingleSlab: false, isDomestic
    let payModeSectionDetails = {
        paymentType: payModeSectionData?.paymentType || payModeSectionData?.[0]?.paymentType,
        isDomestic: payModeSectionData?.isDomestic || payModeSectionData?.[0]?.isDomestic
    }
    // console.log("fields", fields);
    // console.log("default data", payModeSection, payModeSectionData, payModeSectionDetails, defaultBasicFormData);
    const bankSlabsData = getSlabDataWithDetails(payModeSectionDetails, defaultBasicFormData?.PgMidBasicFees || []);
    const newAddFieldInitialData = {
        bankSlabs: bankSlabsData,
    };

    const newAddFieldInitialDataSingleSlab = {
        bankSlabs: getSlabData(payModeSectionData, true),
    };


    const selectedSchemes = fields.getAll()?.filter(data => {console.log(data); return data.cardType}).map(item => item.cardType) || [];

    // console.log("selected schemes", payModeSectionData);

    const filteredSchemeOptions = schemeOptions && schemeOptions.filter(
        options => !selectedSchemes.includes(options.value)
    )

    const selectedScheme = index => {
        const data = fields.getAll();
        const selectedCardType = data[index].cardType;
        if (selectedCardType && index !== 0) {
            const selectedOption = schemeOptions.find(
                option => option.value === selectedCardType
            );
            return [selectedOption];
        }
        return [];
    };

    // if (fields.length <= 0) {
    //     fields.push(
    //         ['NB', 'UPI', 'WALLET'].includes(payModeSectionData.paymentType)
    //             ? newAddFieldInitialDataSingleSlab
    //             : newAddFieldInitialData
    //     );
    // }

    const selectOptioNmapData = (propPayModeData) => {
        let transformedData = propPayModeData && propPayModeData
        .map(item => {
            const subModeName = item.subModeNameUI;
            if (subModeName) {
                return {
                    label: subModeName,
                    value: subModeName.replace(/\s+/g, '-') + '-' + subModeName
                };
            }
            return null; // or an empty object if preferred
        })
        .filter(item => item !== null);


    return transformedData;
    }

    const networkData = (fieldType, selectedCardTypes, index) => {
        let selectedType = fields?.get(index)?.cardType;
        // console.log(fieldType, selectedCardTypes, index, "SETTED", fields.get(index).cardType);
        if (fieldType === 'Domestic-Credit-Card' || fieldType === 'Domestic-Debit-Card' || fieldType === 'Foreign-Credit-Card' || fieldType === 'Foreign-Debit-Card') {
            // console.log(",,s,", defaultBasicFormData?.schemes);
            if (defaultBasicFormData?.schemes) {
                return defaultBasicFormData?.schemes?.filter((item) => schemensMapp(item))
                ?.filter((item) => {
                    return !selectedCardTypes.includes(item) || item === selectedType;
                })
                .map(item => {
                    return {
                        value: item,
                        label: schemensMapp(item)
                    }
                });
            } else {
                return [{
                    label: "",
                    value: ""
                }]
            }
        }

        if (fieldType === 'Net-Banking') {
            console.log("Net-Banking data here", paymodeData);
            return paymodeData && paymodeData
            .filter((item) => {
                return !selectedCardTypes.includes(item.subMode) || item.subMode === selectedType;
            })
            .map(item => {
                    const subModeName = item.subModeNameUI;
                    if (subModeName) {
                        return {
                            label: subModeName,
                            value: item.subMode
                        };
                    }
                    return null;
                })
                .filter(item => item !== null);
        }

        if (fieldType === 'Wallets') {
            console.log("Wallets data here", walletData);
            let transformedData;

            if(walletData?.length > 0){
                transformedData = walletData
                .filter((item) => {
                    // console.log(item);
                    const subModeName = item.subModeNameUI;
                    const value= subModeName;
                    return !selectedCardTypes.includes(value) || value === selectedType;
                })
                .map(item => {
                    const subModeName = item.subModeNameUI;
                    if (subModeName) {
                        return {
                            label: subModeName,
                            value: subModeName
                        };
                    }
                    return null;
                })
                .filter(item => item !== null);
            }
            else {
                transformedData = []
            }
            return transformedData;
        }

        return [];
    }

    const selectedCardTypes = fields.getAll().map(item => item.cardType);

    console.log(fields.getAll(), "fields.getAll()");

    return (

        <>
            {fields.map((item, index) => {
                return (
                    <>
                        <div className="bank-wrap">
                            <Field
                                wrapperClass="surcharge-bank"
                                name={`${item}.cardType`}
                                id={`${item}-issuerId`}
                                component={FormElems.Select}
                                data={
                                    networkData(fields?.name, selectedCardTypes, index)
                                }
                                // label={
                                //     index === 0 ? 'All Schemes' : 'Select Scheme'
                                // }
                                label={fields?.name === 'Wallets'
                                    ? (index === 0 ? 'All Wallet Options' : 'Select Wallet Options')
                                    : fields?.name === 'Net-Banking'
                                        ? (index === 0 ? 'All Banks' : 'Add Bank')
                                        : (index === 0 ? 'All Schemes' : 'Select Scheme')
                                }
                                labelField="label"
                                valueField="value"
                                disabled={isViewMode || index === 0}
                                borderRadius="5px"
                            />
                            {index > 0 ? (
                                <FormElems.Button
                                    customClass="remove-button"
                                    buttonType="secondary"
                                    id={`remove-${item}-issuerId`}
                                    text="x Remove"
                                    type="button"
                                    isDisable={isViewMode}
                                    handleClick={() => fields.remove(index)}
                                />
                            ) : (
                                <FormElems.Button
                                    customClass="add-button"
                                    buttonType="secondary"
                                    id={`add-${item}-issuerId`}
                                    // text="+ Add Schemes"
                                    text={fields?.name === 'Net-Banking' ? '+ Add Bank' : '+ Add Schemes'}
                                    type="button"
                                    isDisable={isViewMode}
                                    handleClick={() => {
                                        let slabData = newAddFieldInitialData;
                                        console.log('Slab data... while add', slabData);
                                        if (slabData?.bankSlabs?.length) {
                                            fields.push({ ...slabData });
                                        } else {
                                            toast.info('No data is configured for the item.');
                                        }
                                    }
                                    }
                                />
                            )}
                        </div>
                        <ul className="slabCard-container border-bottom">
                            <FieldArray
                                name={`${item}.bankSlabs`}
                                component={renderSurchargeSlabItems}
                                schemeOptions={schemeOptions}
                                props={{ isViewMode, payModeSection, defaultBasicFormData }}
                            />
                        </ul>
                    </>
                );
            })}
        </>
    );
};
renderComponent.propTypes = {
    fields: PropTypes.object.isRequired,
    meta: PropTypes.object,
    sectionData: PropTypes.object,
    schemeOptions: PropTypes.array,
    isViewMode: PropTypes.bool,
};
// card slabs
const renderSurchargeSlabItems = ({
    fields,
    meta: { error, submitFailed },
    isViewMode,
    payModeSection,
    defaultBasicFormData
}) => {
    // const section = sectionData.length > 0 ? sectionData : [];
    // eslint-disable-next-line react/prop-types

    const section = fields.getAll();
    // console.log('section slab all', payModeSection, section);
    // if lower slab <=2000 and higherslab is null
    const noSlab =
        section &&
        section.find(item => {
            return (
                item.lowerSlab !== null &&
                item.lowerSlab < 2000 &&
                !item.higherSlab
            );
        });
    // console.log("no slab", noSlab);
    const cardTitle = title => {
        if(typeof title === 'string') {
            return title;
        }
        if (title === 1) {
            return 'SURCHARGE';
        }else if (title === 0) {
            return 'MDR';
        }
        return '';
    };
    const tiles = (item, index) => {
        return (
            <li className={'cardTile'}>
                <div className="slab-title">
                    <div className="title">
                        {cardTitle(section[index]?.feeType)}
                    </div>
                </div>
                <div className="form-section">
                    <div className="form-field">
                        <p className="label">Percent</p>
                        <Field
                            name={`${item}.feePercent`}
                            id={`${item}-feePercent`}
                            type="text"
                            component={FormElems.Input}
                            placeholder="%"
                            postfixContent="%"
                            disabled={isViewMode}
                            borderRadius="5px"
                            maxDecimals={4}
                        />
                    </div>
                    <div className="form-field">
                        <p className="label">Flat</p>
                        <Field
                            name={`${item}.feeFlat`}
                            id={`${item}-feeFlat`}
                            type="text"
                            component={FormElems.Input}
                            placeholder="INR"
                            disabled={isViewMode}
                            maxDecimals={2}
                        />
                    </div>
                    <div className="form-field">
                        <p className="label">Criteria</p>
                        <Field
                            name={`${item}.feeCriteria`}
                            id={`${item}-feeCriteria`}
                            data={getLabelValuePG(defaultBasicFormData?.feeCriteria || [], true)}
                            labelField="label"
                            valueField="value"
                            component={FormElems.Select}
                            label="Criteria"
                            disabled={isViewMode}
                        />
                    </div>
                    <div className="form-field">
                        <p className="label">Tax</p>
                        <Field
                            name={`${item}.tax`}
                            id={`${item}-tax`}
                            type="text"
                            component={FormElems.Input}
                            placeholder="%"
                            postfixContent="%"
                            disabled={isViewMode}
                            borderRadius="5px"
                            maxDecimals={2}
                        />
                    </div>
                </div>
            </li>
        );
    };
    const renderSlabs = () => {
        // get left slabs
        const leftSlab = fields.map((item, index) => {
            console.log("leftslabbb", item)
            if (
                section[index].higherSlab &&
                section[index].higherSlab <= 2000
            ) {
                return tiles(item, index);
            }
        });
        // get right slabs
        const rightSlab = fields.map((item, index) => {
            console.log("rightslabbb", item)
            if (section[index].lowerSlab && section[index].lowerSlab >= 2000) {
                return tiles(item, index);
            }
        });
        if(payModeSection == 'Domestic-Credit-Card' || payModeSection == 'Foreign-Credit-Card' || payModeSection == 'Net-Banking' || payModeSection == 'Wallets'){
            return (
                <>
                    <ul className="leftSlab-container slabCard-container slab">
                        {leftSlab}
                    </ul>
                </>
            );
        }
        else{
            return (
                <>
                    <ul className="leftSlab-container slabCard-container slab">
                        <div className="slab-heading">Slab - Upto 2000 </div>
                        {leftSlab}
                    </ul>
                    <ul className="rightSlab-container slabCard-container slab">
                        <p className="slab-heading">Slab - Above 2000 </p>
                        {rightSlab}
                    </ul>
                </>
            );
        }
    };
    if (noSlab) {
        return fields.map((item, index) => {
            return tiles(item, index);
        });
    }
    return <div>{renderSlabs()}</div>;
};
renderSurchargeSlabItems.propTypes = {
    fields: PropTypes.object.isRequired,
    meta: PropTypes.object,
    sectionData: PropTypes.object,
    schemeOptions: PropTypes.array,
    isViewMode: PropTypes.bool,
};

const mapStateToProps = ({
    merchantData,
    auth,
    form,
    staticData,
    paymentGatewayCredentialsData,
}) => ({
    merchantData,
    auth,
    formData: form['pg-credentials-pricing-form'],
    staticData,
    paymentGatewayCredentialsData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            change,
            createPaymentGatewayCredentialStepRequest,
            resetPaymentGatewayCredentialCreateFormData,
            updatePaymentGatewayCredentialStepRequest,
            resetPaymentGatewayCredentialUpdateFormData,
            fetchPaymentGatewayCredentialDataRequest,
            showLoader,
            hideLoader,
            fetchPaymentModesRequest,
            fetchFormDataPricingSectionRequest
        },
        dispatch
    ),
});

PGCredentialsPricingForm.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    staticData: PropTypes.object,
    handleSubmit: PropTypes.func,
    formData: PropTypes.object,
    change: PropTypes.func,
    paymentGatewayCredentialsData: PropTypes.object,
    merchantData: PropTypes.object,
};

export default compose(
    reduxForm({
        form: 'pg-credentials-pricing-form',
        validate: pgCredentialsPricingFormValidator,
        enableReinitialize: true,
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(PGCredentialsPricingForm);
